<template>
  <div id="app" :class="getCommonStyle.class">
    <router-view :key="Math.random()" />
  </div>
</template>
<script>
import commonbody from '@/components/commonbody.vue';
import { getComAgentData } from '@/utils';
import { mapMutations, mapGetters } from 'vuex';
export default {
  components: {
    commonbody
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['getCommonStyle']),
  },
  methods: {
    ...mapMutations(["setCurrentEquipment"]),
    resize() {
      setTimeout(() => {

        let data = getComAgentData();
        this.setCurrentEquipment(data.type);
      }, 0)
    }
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
}
</script>
<style lang="scss">
#app {
  font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #777;
  display: block;
  margin: 0 auto;
  font-size: 14px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #777;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
